import { IPublicClientApplication } from '@azure/msal-browser';
import { Contact } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createNominationContact, deleteNominationContact, updateNominationContact } from './index';

export const createNominationContactsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createNominationContact: (instance: IPublicClientApplication, nominationId: number, contact: Contact) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createNominationContact(fetchContext, nominationId, contact, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createNominationContact', isInFlight);
    },
  ),
  updateNominationContact: (instance: IPublicClientApplication, contact: Contact) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNominationContact(fetchContext, contact, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNominationContact', isInFlight);
    },
  ),
  deleteNominationContact: (instance: IPublicClientApplication, contactId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteNominationContact(fetchContext, contactId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteNominationContact', isInFlight);
    },
  ),
});
